<tui-editor-socket *ngIf="value" [content]="value" />
